var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col- align-self-center dtema_icon",on:{"click":_vm.hamb}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hamburger"},[_c('i',{staticClass:"fas fa-bars"})])
}]

export { render, staticRenderFns }